import React from "react";

export default function Footer() {
  return (
    <div className="layout-footer">
      <span className="font-medium ml-2">SILOLONA DASHBOARD</span>
    </div>
  );
}
